import BalanceControlRenderer from './BalanceControlRenderer'
import _ from 'underscore'

function SickDaysControlRenderer () {}
SickDaysControlRenderer.prototype = _.create(BalanceControlRenderer.prototype);
SickDaysControlRenderer.prototype.cellGeneralClassName = "sickDaysControlCell";
SickDaysControlRenderer.prototype.getFlagValue = function( value ) {
    return value.sick;
};

export default SickDaysControlRenderer



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/SickDaysControlRenderer.js